import React from "react";
import { IntegrationsAPI } from "../../../providers/IntegrationsAPI";
import { Button } from "../../components/Button";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";

export class GoogleAnalyticsDrawer extends React.Component {
    state = {
        savingOptions: false,
        value: null
    }

    async setAsyncState(data) {
        return new Promise((resolve) => this.setState(data, resolve));
    }

    async componentDidMount() {
        const selectedEnvironment = await EnvironmentStorage.getSelectedEnvironment();
        const google = await IntegrationsAPI.getGoogleKeys(selectedEnvironment)
        const googleTagManager = google?.analytics;
        this.setState({ value: googleTagManager })
    }

    async onSave() {
        try {
            const { onSave } = this.props;

            await this.setAsyncState({ savingOptions: true });
            
            const selectedEnvironment = await EnvironmentStorage.getSelectedEnvironment();
            const response = await IntegrationsAPI.setGoogleAnalytics(selectedEnvironment, this.state.value);

            await this.setAsyncState({ savingOptions: false });
            if (response.getErrors([]).length === 0) {
                onSave && onSave();
            } else {
                alert({ text: `Não foi possível salvar a chave: ${response.getErrors()[0]}` });
            }
            
        } catch(e) {
            await this.setAsyncState({ savingOptions: false });
        }
    }


    render() {
        const { visible, onClose } = this.props;
        const { value, savingOptions } = this.state;

        return (
            <Drawer
                visible={visible}
                onClose={onClose}
                closeInFade
                title={"Google Analytics"}
                footer={
                    <Button
                        design="primary"
                        className="w-100"
                        onClick={this.onSave.bind(this)}
                        loading={savingOptions}
                        disabled={savingOptions}
                    >
                        Salvar alterações
                    </Button>
                }
            >
                <Input
                    design="two"
                    label="Google Analytics ID"
                    placeholder="UA-XXXXX-XX"
                    value={value}
                    onChange={(e) => this.setState({ value: e.target.value })}
                />
            </Drawer>
        )
    }
}
